<template>
  <div class="home">
    <div class="top animate__animated animate__bounce animate__fast"></div>
    <img
      class="logoClass"
      src="../assets/imgs/indexLogo.png"
      alt="logo"
      @click="toDetail"
      @mouseover="addClassName('animate__swing')"
    />
    <div class="center">
      <!-- animate__animated animate__bounceInLeft animate__delay-1s -->
      <div class="logoItem animate__animated animate__fadeInLeft animate__delay-1s" v-for="logo in logos" :key="logo.id">
        <img  class="item" v-for="subItem in logo.item" :key="subItem.src" :class="subItem.className || ''" :src="require('@/assets/imgs/logos/'+subItem.src)" alt="logo" 
          :style="{top: subItem.top, transform: `scale(${subItem.scale})`, left: subItem.left}" @click="toLogoDetail(subItem)">
      </div>
    </div>
    <div
      class="footer2 animate__animated animate__fadeInUp animate__delay-2s"
    ></div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  data() {
    return {
      logos: [
        {
          id: 1,
          item: [
           { src:'1-1.png', top: '-78px',scale: '0.8',left: '40px', name: 'DMC'},
           { src:'1-2.png', top: '-30px',scale: '0.8',left: '40px', name: 'SEC'},
           { src:'1-3.png', top: '30px', scale: '0.8',left: '40px',name: 'TAISEI'},
           { src:'1-4.png', top: '80px', scale: '0.6',left: '50px',className: 'scale1', name: 'FEELER'},
           { src:'1-5.png', top: '80px', scale: '0.5',left: '-50px',className: 'scale1', name: 'FFG'},
           { src:'1-7.png', top: '-30px',scale: '0.8',left: '-40px', name: 'Cross Huller'},
           { src:'1-8.png', top: '-80px',scale: '0.8',left: '-40px', name: 'LAMB'}
          ],
        },
        {
          id: 2,
          item: [
            { src:'2-1.png', top: '-63px',scale: '0.8',left: '90px', name: 'TAKAMAZ-FEELER'},
           { src:'2-2.png', top: '-18px',scale: '0.7',left: '90px', name: 'EQUIPTOP'},
           { src:'2-3.png', top: '22px', scale: '0.6',left: '40px', className: 'scale1', name: 'SACHMAN'},
           { src:'2-4.png', top: '32px', scale: '0.6',left: '-35px',className: 'scale1', name: 'LEADWELL'},
           { src:'2-5.png', top: '24px', scale: '0.5',left: '-100px',className: 'scale1', name: 'SNK'},
           { src:'2-6.png', top: '-18px',scale: '0.8',left: '-120px', name: 'EXCELLO'},
           { src:'2-7.png', top: '-63px',scale: '0.8',left: '-103px', name: 'DSK MACHINERY'}
          ],
        },
        {
          id: 3,
          item: [
          { src:'3-1.png', top: '-32px',scale: '0.5',left: '230px',className: 'scale1', name: 'ECOCA'},
           { src:'3-2.png', top: '-25px',scale: '0.5',left: '198px', className: 'scale1', name: 'SIGMA'},
           { src:'3-3.png', top: '-21px', scale: '0.5',left: '164px', className: 'scale1', name: 'WAIDA FEELER'},
           { src:'3-4.png', top: '-23px', scale: '0.5',left: '78px',className: 'scale1', name: 'JOBS'},
           { src:'3-5.png', top: '-23px', scale: '0.5',left: '17px', className: 'scale1', name: 'MAG'},
           { src:'3-6.png', top: '-23px',scale: '0.5',left: '-6px', className: 'scale1', name: 'SMS'},
           { src:'3-7.png', top: '-23px',scale: '0.5',left: '-43px', className: 'scale1', name: 'Honsberg'}
          ],
        },
        {
          id: 4,
          item: [
            { src:'4-1.png', top: '-18px',scale: '0.6',left: '131px', name: 'SNK NISSSIN'},
           { src:'4-2.png', top: '-46px',scale: '0.6',left: '104px', name: 'Meccanodora'},
           { src:'4-3.png', top: '-61px', scale: '0.5',left: '53px', className: 'scale1', name: 'TACCHELLA'},
           { src:'4-4.png', top: '-63px', scale: '0.5',left: '-32px',className: 'scale1', name: 'IKEGAI'},
           { src:'4-5.png', top: '-59px', scale: '0.5',left: '-105px',className: 'scale1', name: 'WITZIG FRANK'},
           { src:'4-6.png', top: '-38px',scale: '0.6',left: '-148px', name: 'IMAS'},
           { src:'4-7.png', top: '-13px',scale: '0.6',left: '-165px', name: 'RAMBAUDI'}
          ],
        },
        {
          id: 5,
          item: [
          { src:'5-1.png', top: '-13px',scale: '0.6',left: '131px', name: 'Takeuchi'},
           { src:'5-2.png', top: '-51px',scale: '0.6',left: '104px', name: 'Mectron-FEELER'},
           { src:'5-3.png', top: '-86px', scale: '0.5',left: '59px', name: 'SANCO'},
           { src:'5-4.png', top: '-102px', scale: '0.5',left: '-32px', className: 'scale1', name: 'VDFBOEHRINGER'},
           { src:'5-5.png', top: '-96px', scale: '0.5',left: '-138px', className: 'scale1', name: 'Pfiffner'},
           { src:'5-6.png', top: '-78px',scale: '0.6',left: '-148px', name: 'MORARA'},
           { src:'5-7.png', top: '-36px',scale: '0.6',left: '-165px', name: 'HESSAPP'},
           { src:'5-8.png', top: '0px',scale: '0.6',left: '-165px', name: 'F.T.'}
          ],
        },
      ],
    };
  },
  methods: {
    toAbout() {
      this.$router.push("/about");
    },
    toDetail() {
      this.$router.push("/homeDetail");
    },
    toLogoDetail(item){
      if(item.name == 'FFG') {
       return this.$router.push("/homeDetail");
      }
      if(item.name){
        this.$router.push(`/about?name=${item.name}`);
      }
    },
    addClassName() {
      this.logoClass = "logoClass";
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background: url("../assets/imgs/index-background.png") no-repeat 0 0;
  background-size: cover;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  .top {
    width: 100%;
    height: 300px;
    background: url(../assets/imgs/index-02.png) no-repeat center center;
    background-size: contain;
    position: relative;
  }
  img.logoClass {
    position: absolute;
    left: 0;
    top: 120px;
    right: 0;
    margin: auto;
    transition: All 200ms ease-in-out;
    cursor: pointer;
    z-index: 11;
    &:hover {
      transform: scale(1.1);
    }
  }
  .center {
    position: absolute;
    top: 150px;
    bottom: 120px;
    width: 100%;
    height: auto;
    flex: 1;
    z-index: 10;
    .logoItem {
      display: flex;
      justify-content: center;
      height: 120px;
      width: 100%;
      padding: 0 60px;
      box-sizing: border-box;
      margin-top: 10px;
      
      img{
        transition: All 200ms ease-in-out;
        transform: scale(0.8);
        position: relative;
        cursor: pointer;
        &:hover{
          transform: scale(0.9) !important;
        }
        &.scale1:hover{
          transform: scale(0.65) !important;
        }
      }
    }
    .logImg {
      width: 100px;
      height: 80px;
      margin-right: 10px;
    }
  }
  .footer2 {
    width: 100%;
    height: 375px;
    background: url("../assets/imgs/index-04.png") no-repeat center center;
    background-size: contain;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0px;
  }
}
@for $i from 0 to 3 {
  .item-#{$i} {
    transform: rotateY(60 + $i * 4deg);
  }
}
@for $i from 5 to 8 {
  .item-#{$i} {
    transform: rotateY(-60 + $i * 4deg);
  }
}
</style>
